module.exports = __webpack_public_path__ + "static/img/openaccess_socialmedia_1.d6a2057.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/openaccess_socialmedia_1.png
// module id = aHV5
// module chunks = 6